<script setup lang="ts">
import {
  computed,
} from "vue";
import {
  Headset,
} from "@lucide/vue";
import {
  useSessionStore,
} from "~/stores/session";
import {
  useContactSupportDialog,
} from "~/services/contact-support-dialog";

const emit = defineEmits<{
  click: [];
}>();

const sessionStore = useSessionStore();

const canContactSupport = computed(() => {
  const roles = sessionStore.userRoles;
  return (
    roles.includes("TENANT_ADMIN")
    || roles.includes("TENANT_MANAGER")
    || roles.includes("EMPLOYER_ADMIN")
    || roles.includes("EMPLOYER_MANAGER")
  );
});

const handleClick = () => {
  emit("click");
  void useContactSupportDialog();
};
</script>

<template>
  <template v-if="canContactSupport">
    <div
      class="flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm text-gray-700 transition-colors hover:bg-gray-100/80 dark:text-gray-200 dark:hover:bg-gray-700/60"
      @click="handleClick"
    >
      <Headset
        :size="18"
        class="text-gray-600 dark:text-gray-300"
      />
      <span class="font-normal text-gray-800 dark:text-gray-200">{{ $t('NAV.CONTACT_SUPPORT') }}</span>
    </div>
  </template>
</template>
